import React from 'react';

const TakingLeaveHeader = () => {
  return (
    <div style={{ display: 'flex' }}>
      <div
        style={{ width: '25%' }}
        className={'add_user_fourth_step_table_header'}
      >
        Month
      </div>
      <div
        style={{ width: '25%' }}
        className={'add_user_fourth_step_table_header'}
      >
        Accrual day
      </div>
      <div
        style={{ width: '25%' }}
        className={'add_user_fourth_step_table_header'}
      >
        Accrued entitlement (days)
      </div>
      <div
        style={{ width: '25%' }}
        className={'add_user_fourth_step_table_header'}
      >
        Reset counters
      </div>
    </div>
  );
};

export default TakingLeaveHeader;
